export const CONTROLLER_CONSTANTS = {
  ACCOUNT: 'Account',
  DOCUMENT: 'Document',
  CHAT: 'Chat',
  COLLECTION:'Collections',
  VISUALIZATION:'Visualization',
  TENANT_MEMBERS: 'TenantMembers'
} as const;
